export enum truckdriverTypes {
    TRUCKDRIVER_DATA = 'TRUCKDRIVER_DATA'
}